import { OrderHistory, ResponseError } from '@ynap/api-utils'
import { timeout, delay } from '@ynap/promise-utils'
import { push } from 'connected-react-router'
import { CREATE_RETURN_REQUEST, CREATE_RETURN_SUCCESS, CREATE_RETURN_ERROR } from '../constants/ActionTypes'

function createReturnRequest() {
    return {
        type: CREATE_RETURN_REQUEST,
    }
}

function createReturnSuccess(newReturnOrExchangeId) {
    return {
        type: CREATE_RETURN_SUCCESS,
        newReturnOrExchangeId,
    }
}

function createReturnError() {
    return {
        type: CREATE_RETURN_ERROR,
    }
}

export default function createReturn(returnOrder, country) {
    return (dispatch, getState, fetch) => {
        const { locale, config, router = {}, uberToken } = getState()
        const { location = {} } = router
        const { pathname } = location
        const { clientRequest } = config.head
        const { baseUrl, clientId } = config.global.services.commerce
        const { brandId } = config.global.application
        const {
            returnLines,
            orderNumber,
            refundPaymentMethod,
            returnShippingMethod,
            bankName,
            accountName,
            swiftCode,
            accountNo,
            bankCode,
            sortCode,
            branchName,
            email,
        } = returnOrder

        const filteredReturnLines = returnLines.map((line) => {
            const { returnOrExchange, exchangePartnumber, selectedProductColour, ...rest } = line
            if (returnOrExchange === 'exchange') {
                return {
                    exchangePartnumber,
                    ...rest,
                }
            } else {
                return { ...rest }
            }
        })

        const filteredReturnOrder = {
            orderNumber: orderNumber.trim(),
            refundPaymentMethod: refundPaymentMethod === 'STORE_CREDIT' ? refundPaymentMethod : undefined,
            returnLines: filteredReturnLines,
            returnShippingMethod,
            bankName,
            accountName,
            swiftCode,
            bankCode,
            sortCode,
            branchName,
            accountNo,
        }

        const request = OrderHistory.createReturn({
            baseUrl,
            brandId,
            country,
            langId: locale.langId,
            returnOrder: filteredReturnOrder,
            uberToken,
            clientId,
            email,
        })

        dispatch(createReturnRequest())

        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok, status } = response

                if (ok) {
                    return response.json().then((res) => {
                        const returnOrExchangeOrderId = res.returnOrderNumber || res.exchangeOrderNumber
                        return dispatch(createReturnSuccess(returnOrExchangeOrderId))
                    })
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`))
                }

                throw new ResponseError(response)
            })
            .catch((error) => {
                dispatch(createReturnError())
                throw error
            })
    }
}
